import { Check } from "@tamagui/lucide-icons";
import type React from "react";
import { View, type ViewProps, XStack } from "tamagui";
import { Body } from "../../ui/Body";
import { Label } from "../../ui/Label";

export const PrimaryCheck: React.FC<ViewProps> = (props) => {
  return (
    <View
      {...props}
      padding={2}
      backgroundColor={"$primary"}
      borderRadius={8}
      borderColor={"$backgroundBlock"}
      borderWidth={1}
      alignSelf="flex-start"
      marginTop={1}
    >
      <Check size={12} />
    </View>
  );
};

export const PrimaryCheckText: React.FC<{
  text: JSX.Element | string;
  label?: boolean;
}> = ({ text, label }) => {
  const TextComponent = label ? Label : Body;

  return (
    <XStack gap={"$small"}>
      <PrimaryCheck />
      <TextComponent>{text}</TextComponent>
    </XStack>
  );
};
